module.exports = __webpack_public_path__ + "static/media/chip1.2cdbbb2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/bcase/assets/chip1.png
// module id = 2562
// module chunks = 0